import React from 'react';
import { FormChannelsContextProvider } from '../context';
import { Edit } from './edit';

export const GroupEdit: React.FC = () => (
  <FormChannelsContextProvider>
    <Edit />
  </FormChannelsContextProvider>
);

export default GroupEdit;
